import { mixinFreeColor } from './mixinVars';
export const greenVars = {
    // 工作桌面导航背景颜色
    '--workbench-nav-bg-color': '#08964A',
    // 工作桌面导航栏搜索框hover边框颜色
    '--workbench-search-app-hover-border-color': '#64d497',
    // 工作桌面导航栏搜索框hover背景色
    '--workbench-search-app-hover-bg-color': '#23aa61',
    // 工作桌面导航栏搜索框默认边框颜色
    '--workbench-search-app-border-color': '#15b25d',
    // 工作桌面导航栏搜索框默认背景色
    '--workbench-search-app-bg-color': '#199e56',
    // 工作桌面导航栏搜索框默认文字颜色
    '--workbench-search-app-input-color': '#dfdfdf',
    // 工作桌面导航栏应用菜单扇叶颜色
    '--workbench-nav-allapps-color': '#05a74f',
    // 工作桌面导航栏应用菜单扇叶hover颜色
    '--workbench-nav-allapps-hover-color': '#009f49',
    // 面包屑文字颜色 
    '--workbench-nav-breadcrumb-color': '#c9c9c9',
    // 面包屑hover底色
    '--workbench-nav-breadcrumb-hover-bg-color': '#0fa74f',
    // 应用菜单 标题 颜色
    '--workbench-allapps-title-color': '#009443',
    // 应用菜单 竖线颜色
    '--workbench-allapps-line-color': '#009443',
    // 个人中心文字hover颜色
    '--workbench-user-info-hover': '#009443',
    // 桌面配置顶部页签文字 底部横线 颜色
    '--workbench-desktop-setting-title-color': '#009443',
    // 桌面配置 当前分组页面背景色
    '--workbench-home-current-tab-bg-color': '#009443',
    // 桌面配置 编辑态 当前分组页签文字颜色
    '--workbench-home-tab-editable-current-title-color': '#009443',
    // 导航栏工作台选中激活颜色
    '--workbench-nav-active': mixinFreeColor('#08964A', 0.85),
    // 导航栏图标颜色
    '--workbench-nav-icon-color': '#fff',
    //搜索栏中主色调设为白色
    '--workbench-nav-search-color': '#fff',
    //搜索栏背景色
    '--workbench-nav-search-bg': 'rgba(255, 255, 255, 0.1)',
    //搜索栏边框颜色
    '--workbench-nav-border-color': 'rgba(255,255,255,0.2)',
    //搜索栏其他色边框聚焦颜色
    '--workbench-nav-border-color-focus': 'rgba(255,255,255,0.5)',
    //搜索栏边框hover颜色
    '--workbench-nav-border-color-hover': 'rgba(255,255,255,0.2)',
    //搜索栏竖线透明度
    '--workbench-nav-search-shuxian-opacity': 0.2,
    //搜索栏select框背景色
    '--workbench-nav-select-bg-color': 'white',
    //搜索栏select框文字hover时的颜色
    '--workbench-nav-select-text-color': 'rgba(240, 240, 240)',
    //搜索框联想面板的字体颜色
    '--workbench-nav-search-more-color': '#2B2C42',
    //搜索框联想面板的分类标题颜色
    '--workbench-nav-search-title-color': '#2B2C42',
    //搜索框联想面板标题背景颜色
    '--workbench-nav-title-bg-color': '#F8F8F8',
    //搜索栏下拉框图标颜色
    '--workbench-nav-select-drop-color': 'rgba(255,255,255,0.8)',
    //搜索栏下拉选中字体颜色
    '--workbench-nav-select-drop-text-color': 'rgba(233,240,250)',
    //搜索栏暂无数据搜索图标颜色
    '--workbench-nav-search-icon-sousuo1-color': '#d1d1d1',
    //搜索栏横线颜色
    '--workbench-nav-search-hr-color': '#F0F0F0',
    //内部页签标签栏背景色
    '--workbench-tab-wrapper-bg': '#F5FAF6',
    //内部页签选中字体颜色
    '--workbench-tab-active-color': '#33703F',
    //内部页签标签栏背景下划线
    '--workbench-tab-bottom-color': 'rgba(51, 112, 63, 0.22)',
    // 面包屑首页下拉图标颜色
    '--workbench-breadcrumb-home-icon-c': '#fff',
    // 面包屑首页下拉图标透明度
    '--workbench-breadcrumb-home-icon-o': 0.9,
    // 面包屑首页下拉图标边框透明度
    '--workbench-breadcrumb-home-icon-bo': 0.6,
    // 基于主色hsl格式，l值为93
    '--workbench-color-primary-l93': "#E7F4E9",
    '--workbench-color-primary-l95': "#E6FDF1",
};